export default __webpack_public_path__ + "static/media/NewWebGroup总部.4edd9023.jpg";